export default __webpack_public_path__ + "static/media/logo_trustpilot.42830b45.svg";